import { render, staticRenderFns } from "./update-coverage-tier.component.vue?vue&type=template&id=1c1e07a8&"
import script from "./update-coverage-tier.component.vue?vue&type=script&lang=ts&"
export * from "./update-coverage-tier.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports